module.exports = __webpack_public_path__ + "img/prot-2000.873fd6ab.png";